<template>
  <div class="contest-detail-container">
    <!-- 顶部横幅 -->
    <TopHeader />

    <!-- 主内容 -->
    <div class="main-content">
      <div class="back-link" @click="goBack">
        <img src="@/assets/image/back.png" class="back-icon" />
        <span>第172场双周赛</span>
      </div>

      <div class="content-card">
        <h2 class="section-title">活动详情</h2>
        
        <div class="detail-content">
          <h3>第 172 场双周赛</h3>
          
          <p>为保障赛事的公平性，力扣将在赛事中隐藏部分明细。当参赛者在赛事中提交未通过时，力扣不会向该参赛者披露被隐藏的错误用例。</p>
          <p>本场赛事的排名将会在赛事结束后的 5 个工作日内确认。</p>
          
          <p class="red-dot">● 赛事中的违规行为：</p>
          <p>一人使用多账号与多【力扣（中文社区）LCCN、和「LeetCode」LCCS】账号等属于两个账号。</p>
          <p>多账号交叉使用同 IP（作弊）。</p>
          <p>使用非正常手段影响他人竞赛的。</p>
          <p>发现代码在社区内被发布等行为的。</p>
          <p>严禁使用任何代码生成工具或者外部辅助手段解题，包括但不限于将题目描述、测试用例或解题代码输入到外部辅助工具中的行为。</p>
          
          <p class="warning">⚠ 如有用户被检查出赛事中存在违规行为，力扣将采取以下处罚措施：</p>
          <p>第一次违规：▲ 账号内的所有积分清空，原账号冻结 1 个月。</p>
          <p>第二次违规：▲ 永久封号。</p>
          
          <p class="success">✓ 我们加大力度维护竞赛的公平性，成功举报违规用户可获得奖励：</p>
          <p>被认定为违规账号的 10 名举报者，每人可获得 20 积分奖励。</p>
          <p>每人每场最高可获得 100 积分奖励。</p>
          
          <p class="warning">⚠ 为保证竞赛的公平性，请你在竞赛结束前在讨论区发布讨论可能影响竞赛正常进行的内容，否则管理员将视情况进行管理、删除、禁言或封号等，严重者可能被起诉。</p>
          
          <p class="notice">☞ 通知</p>
          <p>务必按照报名后方能参加本场赛事，祝您竞赛愉快！</p>
          
          <div class="divider"></div>
          
          <p>为保障赛事的公平性，力扣将在赛事中隐藏部分明细。当参赛者在赛事中提交未通过时，力扣不会向该参赛者披露被隐藏的错误用例。</p>
          <p>本场赛事的排名将会在赛事结束后的 5 个工作日内确认。</p>
          
          <p class="red-dot">● 赛事中的违规行为：</p>
          <p>一人使用多账号与多【力扣（中文社区）LCCN、和「LeetCode」LCCS】账号等属于两个账号。</p>
          <p>多账号交叉使用同 IP（作弊）。</p>
          <p>使用非正常手段影响他人竞赛的。</p>
          <p>发现代码在社区内被发布等行为的。</p>
          <p>严禁使用任何代码生成工具或者外部辅助手段解题，包括但不限于将题目描述、测试用例或解题代码输入到外部辅助工具中的行为。</p>
          
          <p class="warning">⚠ 如有用户被检查出赛事中存在违规行为，力扣将采取以下处罚措施：</p>
          <p>第一次违规：▲ 账号内的所有积分清空，原账号冻结 1 个月。</p>
          <p>第二次违规：▲ 永久封号。</p>
          
          <p class="success">✓ 我们加大力度维护竞赛的公平性，成功举报违规用户可获得奖励：</p>
          <p>被认定为违规账号的 10 名举报者，每人可获得 20 积分奖励。</p>
          <p>每人每场最高可获得 100 积分奖励。</p>
          
          <p class="warning">⚠ 为保证竞赛的公平性，请你在竞赛结束前在讨论区发布讨论可能影响竞赛正常进行的内容，否则管理员将视情况进行管理、删除、禁言或封号等，严重者可能被起诉。</p>
        </div>
      </div>

      <div class="back-top" @click="scrollToTop">
        <img src="@/assets/image/up.png" class="arrow-icon" />
        <span>顶部</span>
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue'

export default {
  name: 'ContestDetail',
  components: {
    TopHeader
  },
  data() {
    return {
    }
  },
  methods: {
    goBack() {
      this.$router.push('/home')
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.contest-detail-container {
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 70px;
}

.main-content {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #333;
  font-size: 16px;
  margin-bottom: 20px;
  cursor: pointer;
  padding: 10px 0;
}

.back-icon {
  width: 16px;
  height: 16px;
}

.back-link:hover {
  color: #3d8c40;
}

.content-card {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
}

.section-title {
  font-size: 16px;
  color: #333;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}

.detail-content h3 {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
}

.detail-content p {
  font-size: 14px;
  color: #666;
  line-height: 2;
  margin: 0;
}

.detail-content .red-dot {
  color: #e74c3c;
  margin-top: 15px;
}

.detail-content .warning {
  color: #e67e22;
  margin-top: 15px;
}

.detail-content .success {
  color: #27ae60;
  margin-top: 15px;
}

.detail-content .notice {
  color: #333;
  margin-top: 15px;
  font-weight: 500;
}

.divider {
  height: 1px;
  background: #eee;
  margin: 30px 0;
}

.back-top {
  position: fixed;
  right: 30px;
  bottom: 30px;
  padding: 10px 15px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
}

.arrow-icon {
  width: 12px;
  height: 12px;
}

.back-top:hover {
  border-color: #3d8c40;
  color: #3d8c40;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .main-content {
    padding: 15px;
  }

  .back-link {
    font-size: 14px;
  }

  .content-card {
    padding: 20px 15px;
  }

  .section-title {
    font-size: 15px;
  }

  .detail-content h3 {
    font-size: 15px;
  }

  .detail-content p {
    font-size: 13px;
    line-height: 1.8;
  }

  .back-top {
    right: 15px;
    bottom: 20px;
  }
}
</style>
